import React from 'react';
import { Box } from '@material-ui/core';
import Copyright from '../../Copyright';

export default () => (
  <Box bottom={0} padding={2} width="100%" marginX="auto" textAlign="center">
    <Copyright />
  </Box>
);
